export default "/static/empty/no-reports.png"